import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import { TCorePage } from "../../../../Types";
import BanButtons from "./BanButtons";
import ResolveButtons from "./ResolveButtons";
import ET3Div from "../../../../core/et3-div";
import React from "react";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const ActionButtons = withLiteObserverAndTheme<{
  reporterId: number;
  reportedId: number;
  reportedIsSilentBanned: number;
  reportedUUID: string;
  reportId: number;
  status: string;
  pageName: TCorePage;
}>((props) => {
  const {
    reportedId,
    reportedIsSilentBanned,
    pageName,
    status,
    reportId,
    reporterId,
    reportedUUID,
    theme
  } = props;
  const { colors } = theme;
  const pendingReport = status === "pending";

  return pendingReport ? (
    <React.Fragment>
      <ET3Div
        isScrollable={false}
        color={colors.all.transparent}
        isExtendable={false}
        fDirection="column"
        justifyContent="center"
        alignItems="flex-start"
        withShadow={false}
        width={220}
        height={540}
        style={{}}
        onClick={() => {}}
      >
        <BanButtons
          reportedUUID={reportedUUID}
          reportedID={reportedId}
          reportedIsSilentBanned={reportedIsSilentBanned}
          reportID={reportId}
          pageName={pageName}
        />
        <Et3Margin top={15} bottom={0} right={0} left={0} />
        <ResolveButtons
          reportedId={reportedId}
          reportId={reportId}
          reporterId={reporterId}
          pageName={pageName}
        />
      </ET3Div>
    </React.Fragment>
  ) : null;
});
export default ActionButtons;
